"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.type.text': 'Texto',
    'question.type.textarea': 'Área de texto',
    'question.type.select': 'Seleccionar',
    'question.type.radio': 'Radio',
    'question.type.checkbox': 'Casilla de verificación',
    'question.type.number': 'Número',
    'question.type.email': 'Correo electrónico',
    'question.type.url': 'URL',
    'question.type.date': 'Fecha',
};
